import {customTemplateSelection, customTemplateResult} from '../../common/utils/CustomMultiselectHelpers.js';

export default class DrivingTestsResults {
  constructor() {
    this.initializeSelect2();
    this.bindEvents();
  }

  initializeSelect2() {
    const $select = $("#attempt_filter");
    const urlParams = new URLSearchParams(window.location.search);
    const selectedAttempts = urlParams.getAll('attempt_numbers[]');

    $select.select2({
      placeholder: "Select items",
      selectionAdapter: $.fn.select2.amd.require("CustomSelectionAdapter"),
      closeOnSelect: false,
      templateSelection: customTemplateSelection,
      templateResult: customTemplateResult
    });
    $select.data('select2').$dropdown.addClass('custom-multiselect');
    $select.data('select2').$container.addClass('custom-multiselect');
  }

  bindEvents() {
  }
}
